import { getBrokerId, getCID, getEnvironment } from './utils';
export const getPageViewTrackingData = (pageViewData) => {
    const uid = getBrokerId();
    const trackingData = {
        ...pageViewData,
        av_user: {
            uid,
            cid: getCID(),
            contract: 'under contract',
            status: uid ? 'logged' : 'unlogged',
        },
        av_url_path: typeof window !== 'undefined' ? window.location.href : '',
        av_environment: getEnvironment(),
        av_site: 'IWT',
        av_language: 'de',
        av_platform: 'web',
        av_category: 'caf',
        av_flow_type: 'create',
        av_initiative: 'wl_caf',
    };
    return trackingData;
};
